import React, {useState} from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import _extend from 'lodash/extend'
import {CLASSNAME, CLASSNAME_PREFIX, componentClassName, isRequiredClassName} from '../constants'
import DropdownIndicator from '../shared/DropdownIndicator'
import LoadingIndicator from '../shared/LoadingIndicator'
import FloatingLabel from '../shared/FloatingLabel'
import useFocussedPlaceholder from '../../utils/useFocussedPlaceholder'

const PhoenixAsyncSelect = (props) => {
    const {title, outlined, value, components, isRequired} = props
    // eslint-disable-next-line react/destructuring-assignment
    const [originalPlaceholder] = useState(props.placeholder)
    const {isFocussed, placeholder, handleOnFocus, handleOnBlur} = useFocussedPlaceholder(
        false,
        originalPlaceholder || title,
        isRequired
    )

    return (
        <div className={`papi-react ${isRequiredClassName({isRequired, value})}`}>
            <div className={`phoenix-select ${componentClassName(outlined)}`}>
                <FloatingLabel
                    title={title}
                    value={value}
                    isFocussed={isFocussed}
                    isRequired={isRequired}
                    hasCustomPlaceholder={!!originalPlaceholder}
                />
                <AsyncSelect
                    className={CLASSNAME}
                    classNamePrefix={CLASSNAME_PREFIX}
                    placeholder={placeholder}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    isClearable
                    {...props}
                    components={_extend({LoadingIndicator, DropdownIndicator}, components)}
                />
            </div>
        </div>
    )
}

PhoenixAsyncSelect.displayName = 'PhoenixAsyncSelect'

PhoenixAsyncSelect.propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    outlined: PropTypes.bool,
    isRequired: PropTypes.bool,
    isMulti: PropTypes.bool
}

export default PhoenixAsyncSelect
